"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function readonly(target, key) {
    Object.defineProperty(target, key, {
        writable: false
    });
}
exports.readonly = readonly;
//# sourceMappingURL=../../src/dist/readonly/readonly.js.map